import React from 'react';
import { Input as AntdInput } from 'antd';
import { InputProps as AntdInputProps } from 'antd/lib/input';
import classNames from 'classnames';

import './index.less';

interface Props extends Omit<AntdInputProps, 'status'> {
  id: string;
  status?: 'success' | 'error';
  label?: React.ReactNode;
  description?: React.ReactNode;
  message?: React.ReactNode;
  labelClassName?: string;
  messageClassName?: string;
}

export type { Props as InputProps };

export default function Input({
  id,
  label,
  description,
  message,
  status,
  className = '',
  disabled = false,
  labelClassName = 'tw-text-body-3 tw-font-medium',
  messageClassName = 'tw-text-paragraph-100 tw-text-gray',
  ...rest
}: Props): JSX.Element {
  const antdStatus = status === 'error' ? status : void 0;
  return (
    <div className={classNames('sl-input-wrapper', className)}>
      {label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}
      {description && <div className="tw-text-body-3 tw-text-gray">{description}</div>}
      <AntdInput
        id={id}
        className={classNames('tw-rounded focus:tw-shadow-none', {
          'hover:tw-border-gray-600 tw-border-gray-300 focused:tw-border-secondary': !status,
          'tw-border-gray-200 tw-cursor-not-allowed': disabled,
          'tw-border-success hover:tw-border-success-600 focused:tw-border-success-200':
            status === 'success',
        })}
        status={antdStatus}
        disabled={disabled}
        {...rest}
      />
      {message && <div className={messageClassName}>{message}</div>}
    </div>
  );
}
